'use strict';

var Backbone = require('backbone'),
  $ = require('jquery'),
  ModalView = require('../../js/components/ModalView'),
  ProjectDetailsViewAllUsersModal = Backbone.View.extend({

    initialize: function() {

      this.$userTable = $('.FullUsersModal');

    },

    events: {
      click: 'open'
    },

    open: function() {

      if (!this.userModal) {
        this.userModal = new ModalView({
          content: this.$userTable
        });
      }

      this.userModal.open();

    }

  }, {
    create: function($parent) {
      $parent.find('.js-projectDetailsViewAllUsers').each(function(n, el) {
        new ProjectDetailsViewAllUsersModal({
          el: el
        });
      });
    }
  });

module.exports = ProjectDetailsViewAllUsersModal;



// WEBPACK FOOTER //
// ./assets/components/DesignCenter/projectDetailsViewAllUsersModal.js